module.exports = __webpack_public_path__ + "img/logout_black_24dp.cfc0e229.svg";